import { call, put, select } from 'redux-saga/effects';
import { messagingActions } from 'messaging/redux/messagingActions';
import { sendMessagingChannelMessage } from '../../gql/messagigMutations';
import { messagingSelectors } from 'messaging/redux/messagingSelectors';
import { getFirebaseToken } from './firebaseUtils';
import { isString } from 'lodash';

export function* sendNewMessage(): Generator {
    const newMessage = yield select(messagingSelectors.newMessage);
    yield put(messagingActions.changeNewMessage(''));
    const channelId = yield select(messagingSelectors.currentChannelId);
    const firebaseToken = yield call(getFirebaseToken);

    if (isString(newMessage) && isString(channelId) && isString(firebaseToken)) {
        yield put(
            messagingActions.sendNewMessageToServer(sendMessagingChannelMessage, firebaseToken, channelId, newMessage),
        );
    }
}
